import { Component, ReactNode } from 'react'

interface ErrorBoundaryProps {
  children: ReactNode
  fallback?: ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack)
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback

      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', padding: '4rem 1rem', color: 'var(--stonks-text-muted)',
          textAlign: 'center', flex: 1,
        }}>
          <i className="bi bi-exclamation-triangle" style={{ fontSize: '2.5rem', marginBottom: '1rem', opacity: 0.5 }}></i>
          <p style={{ margin: 0, fontSize: '1rem', color: 'var(--stonks-text)' }}>Something went wrong</p>
          <p style={{ margin: '0.5rem 0 1rem', fontSize: '0.8125rem', opacity: 0.7 }}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </p>
          <button
            onClick={this.handleRetry}
            style={{
              padding: '0 16px', height: '32px', background: 'var(--stonks-accent-primary)',
              border: 'none', borderRadius: 'var(--radius-sm)', color: '#fff',
              fontSize: '0.8125rem', fontWeight: 500, cursor: 'pointer',
            }}
          >
            Try Again
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
